import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskNotificationsNotificationEmailRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsNotificationEmailRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import { LazyProjectSettingsNotificationEmail } from './ui/notification-email/index.tsx';
import { ServiceDeskNotificationEmailNextGenRedirect } from './ui/service-desk-notification-email-next-gen-redirect/index.tsx';

const projectSettingsServicedeskNotificationsNotificationEmailPageEntryPoint = createPageEntryPoint(
	{
		main: {
			root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
				/* webpackChunkName: "async-project-settings-servicedesk-notifications-notification-email" */ './ui/service-desk-notification-email-next-gen-redirect/index.tsx',
				{ entryFsSsrLiftImportToModule: false },
			),
			getPreloadProps: () => ({}),
		},
	},
);

export const projectSettingsServicedeskNotificationsNotificationEmailRouteEntry: Route =
	createEntry(
		projectSettingsServicedeskNotificationsNotificationEmailRoute,

		() => ({
			group: 'project-settings-servicedesk',

			// eslint-disable-next-line no-restricted-syntax
			component: fg('nike_entrypoint_migration_batch_2')
				? undefined
				: ServiceDeskNotificationEmailNextGenRedirect,

			entryPoint: () =>
				fg('nike_entrypoint_migration_batch_2')
					? projectSettingsServicedeskNotificationsNotificationEmailPageEntryPoint
					: undefined,
			layout: serviceProjectLayout,

			navigation: {
				menuId: MenuIdProjects,
				sidebarId: SidebarIdProjectSettings,
			},

			resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
			forPaint: [LazyProjectSettingsNotificationEmail],

			bifrost: {
				bifrostGroup: 'shell-only',
			},
		}),
	);
